import { useSession } from "@/auth/session/SessionProvider";
import { ThemeToggle } from "@/theme/ThemeToggle";

/**
 * Top-right header strip: theme toggle and a sign-out button. Renders nothing
 * when not authenticated (the AuthGate shouldn't have admitted us in that case
 * anyway, but defensive). Admin lives on the nav's shield icon, not here.
 *
 * <p>The signed-in email lives on the Profile page (a labelled field), not
 * here — this strip stays to just controls.</p>
 */
export function SignedInHeader() {
  const session = useSession();

  if (!session.isAuthenticated || !session.user) return null;

  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      <ThemeToggle />
      <button
        type="button"
        className="rounded-md border border-amber-300 bg-amber-100 px-2.5 py-1 text-xs font-semibold text-amber-800 transition hover:bg-amber-200 dark:border-amber-800/60 dark:bg-amber-950/40 dark:text-amber-300 dark:hover:bg-amber-900/50"
        onClick={() => session.signOut()}
      >
        Sign out
      </button>
    </div>
  );
}
